import { usePitcher } from "features/utils/usePitcher";

import type { Command } from "../../types";

export const useInitSetupTasks = (): Command => {
  const pitcher = usePitcher();

  return {
    id: "codesandbox.setuptasks.init",
    name: "Run setup tasks",
    section: "Setup",
    subtitle: "Init setup tasks configured in the tasks.json file",
    perform: () => {
      pitcher.clients.setup.init();
    },
  };
};
